import axios from 'axios';
import type { ApiResponse, StarterRequestBookingBody } from '@court-sync/shared';
import { API_BASE_URL } from '../config/api';

export interface StarterRequestBookingResult {
  requestId: string;
}

export const starterRequestBookingService = {
  async submit(
    body: StarterRequestBookingBody
  ): Promise<ApiResponse<StarterRequestBookingResult>> {
    const response = await axios.post<ApiResponse<StarterRequestBookingResult>>(
      `${API_BASE_URL}/public/bookings/starter-request`,
      body,
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  },
};
